import { Switch } from "@/components/ui/switch";
import { EmployeePreferences } from "@/interfaces/employee_type";

export function DashboardLayoutOption({
	preferences,
	setPreference,
	allPrefsForRole,
}: {
	preferences: EmployeePreferences;
	allPrefsForRole: string[];
	setPreference: (
		key: keyof EmployeePreferences,
		value: EmployeePreferences[keyof EmployeePreferences],
	) => void;
}) {
	const enabledSections = (preferences.dashboard_layout as string[]) || [
		...allPrefsForRole,
	];

	const toggleSection = (section: string) => {
		if (enabledSections.includes(section)) {
			setPreference(
				"dashboard_layout",
				enabledSections.filter((string: string) => string !== section),
			);
		} else {
			setPreference("dashboard_layout", [...enabledSections, section]);
		}
	};

	return (
		<div className="flex flex-col gap-3">
			<label className="text-lg font-medium">Dashboard Layout:</label>
			<div className="flex flex-col gap-2 pl-2">
				{allPrefsForRole.map((section) => (
					<div key={section} className="flex flex-row gap-2 items-center">
						<Switch
							checked={enabledSections.includes(section)}
							onCheckedChange={() => toggleSection(section)}
						/>
						<label className="text-base capitalize">
							{section === "mini_project_list"
								? "Project List"
								: section === "ca_project_list"
									? "Construction Admin Projects"
									: section + "s"}
						</label>
					</div>
				))}
			</div>
		</div>
	);
}
